import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FlexBox, Spinner } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { Waypoint } from 'react-waypoint';
/** Represents a loading item. */
export const LoadingItem = ({ asyncStatus, hasNextPage, nextPage, }) => {
    /** Handles changing to the next page. */
    const handleNextPage = useCallback(() => {
        if (hasNextPage) {
            nextPage();
        }
    }, [hasNextPage, nextPage]);
    return (_jsxs(Box, Object.assign({ as: "li" }, { children: [asyncStatus === 'pending' && (_jsx(FlexBox, Object.assign({ justifyContent: "center", padding: "200 300" }, { children: _jsx(Spinner, { size: 20 }) }))), asyncStatus !== 'pending' && _jsx(Waypoint, { onEnter: handleNextPage })] })));
};
